import type { HTMLAttributes } from "react";
import { cx } from "@/utils/cx";
import { UntitledLogoMinimal } from "./untitledui-logo-minimal";

export const UntitledLogo = (props: HTMLAttributes<HTMLOrSVGElement>) => {
    return (
        <div
            {...props}
            className={cx(
                "flex h-8 w-max items-center justify-start overflow-visible",
                props.className,
            )}
        >
            {/* Minimal logo */}
            <UntitledLogoMinimal className="aspect-square h-full w-auto shrink-0" />

            {/* Gap that adjusts to the height of the container */}
            <div className="aspect-[0.3] h-full" />

            {/* Logomark wordmark */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 120 32"
                fill="none"
                className="aspect-[3.5] h-full shrink-0"
            >
                <text
                    x="0"
                    y="22"
                    className="fill-fg-primary"
                    fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif"
                    fontSize="20"
                    fontWeight="600"
                    letterSpacing="0.04em"
                >
                    Kordbooks
                </text>
            </svg>
        </div>
    );
};
